import React, { useState } from 'react';
import './ApproveFormModal.css';

const ApproveFormModal = ({ request, onApprove, onCancel, showAlert }) => {
  const [formData, setFormData] = useState({
    expiryDays: 30,
    notes: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await onApprove(formData);
    } catch (error) {
      showAlert(`Error: ${error.message}`, 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="approve-overlay" onClick={onCancel}>
      <div className="approve-modal" onClick={(e) => e.stopPropagation()}>
        <div className="approve-header">
          <h2>✅ Approve & Generate License</h2>
          <button onClick={onCancel} className="approve-close">
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className="approve-form">
          <div className="approve-info">
            {request.customer_type === 'organisation' ? (
              <>
                <div><strong>Organisation:</strong> {request.org_name}</div>
                <div><strong>System:</strong> {request.system_name || '-'}</div>
                <div><strong>Contact:</strong> {request.client_name}</div>
                {request.email && <div><strong>Email:</strong> {request.email}</div>}
              </>
            ) : (
              <>
                <div><strong>Client:</strong> {request.client_name}</div>
                <div><strong>Email:</strong> {request.email}</div>
              </>
            )}
          </div>

          <div className="approve-field">
            <label className="approve-label">License Validity (Months)</label>
            <select
              value={formData.expiryDays}
              onChange={(e) => setFormData({ ...formData, expiryDays: parseInt(e.target.value) })}
              className="approve-select"
            >
              {[1, 3, 6, 12, 24, 36].map(months => (
                <option key={months} value={months * 30}>
                  {months} month{months > 1 ? 's' : ''}
                </option>
              ))}
            </select>
          </div>

          <div className="approve-field">
            <label className="approve-label">Notes (Optional)</label>
            <textarea
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              rows="3"
              className="approve-textarea"
            />
          </div>

          <div className="approve-actions">
            <button
              type="button"
              onClick={onCancel}
              disabled={submitting}
              className="approve-btn-cancel"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="approve-btn-submit"
            >
              {submitting ? '⏳ Generating...' : '✅ Approve & Generate'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ApproveFormModal;